import { useEffect, useState } from 'react';

/**
 * Progresso de leitura da página, de 0 a 1 — para a barra fixa no topo.
 * Recalcula em `scroll` e `resize`. Guardado para SSR/teste: `window` não
 * existe em todo ambiente que importa este módulo.
 */
export function useScrollProgress(): number {
  const [progresso, setProgresso] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    function medir(): void {
      const alturaTotal = document.documentElement.scrollHeight - window.innerHeight;
      if (alturaTotal <= 0) {
        setProgresso(0);
        return;
      }
      const atual = window.scrollY / alturaTotal;
      setProgresso(Math.min(1, Math.max(0, atual)));
    }

    medir();
    window.addEventListener('scroll', medir, { passive: true });
    window.addEventListener('resize', medir);
    return () => {
      window.removeEventListener('scroll', medir);
      window.removeEventListener('resize', medir);
    };
  }, []);

  return progresso;
}
